import {
  Environment
} from '@vodacom/web-env';

import {
  TabList
} from 'constants/tabs';

import {
  Cities,
  TechnicalErrorDetails
} from 'constants/common';

import {
  PopupConfig
} from 'constants/otp-config';

const Environments = {
  Local: {
    name: 'Local',
    env: 'dev',
    uiHost: 'http://localhost:3000',
    uiBase: '/',
    apiHost: 'https://apiqa.vodacom.co.za/connectu/v1',
    apiBase: '/',
    j4uHost: 'https://apiqa.vodacom.co.za/connectu/j4u/v2',
    j4uBase: '/',
    advancesHost: 'https://apiqa.vodacom.co.za/connectu/advances/v1',
    advancesBase: '/',
    authHost: 'https://apiqa.vodacom.co.za/connectu/auth/v1',
    authBase: '/',
    catalogueHost: 'https://apiqa.vodacom.co.za/connectu/ecom/catalogue/rest/services/v1',
    catalogueBase: '/',
    checkoutHost: 'https://apiqa.vodacom.co.za/connectu/ecom/order/rest/services/v1',
    checkoutBase: '/',
    socialBundleHost: 'https://apiqa.vodacom.co.za/connectu/socialbundle/v1',
    socialBundleBase: '/',
    assetBase: '/assets/',
    drupalBaseUrl: 'https://connectudev.vodacom.co.za',
    headerEnrichmentUrl: 'https://enrichmentstg.vodacom.co.za/cloud/enrichment/loader',
    sentryEnv: 'LOCAL',
    sentryTracesSampleRate: 1.0,
    locationTimeout: 30000,
    cities: Cities,
    technicalErrorDetails: TechnicalErrorDetails,
    popupConfig: PopupConfig,
    tabList: TabList
  },
  Dev: {
    name: 'Development',
    env: 'dev',
    uiHost: 'https://connectudev.vodacom.co.za',
    uiBase: '/',
    apiHost: 'https://apidev.vodacom.co.za/connectu/v1',
    apiBase: '/',
    j4uHost: 'https://apidev.vodacom.co.za/connectu/j4u/v2',
    j4uBase: '/',
    advancesHost: 'https://apidev.vodacom.co.za/connectu/advances/v1',
    advancesBase: '/',
    authHost: 'https://apidev.vodacom.co.za/connectu/auth/v1',
    authBase: '/',
    catalogueHost: 'https://apidev.vodacom.co.za/connectu/ecom/catalogue/rest/services/v1',
    catalogueBase: '/',
    checkoutHost: 'https://apidev.vodacom.co.za/connectu/ecom/order/rest/services/v1',
    checkoutBase: '/',
    socialBundleHost: 'https://apidev.vodacom.co.za/connectu/socialbundle/v1',
    socialBundleBase: '/',
    assetBase: '/assets/',
    drupalBaseUrl: 'https://connectudev.vodacom.co.za',
    headerEnrichmentUrl: 'https://enrichmentstg.vodacom.co.za/cloud/enrichment/loader',
    sentryEnv: 'development',
    sentryTracesSampleRate: 1.0,
    locationTimeout: 30000,
    cities: Cities,
    technicalErrorDetails: TechnicalErrorDetails,
    popupConfig: PopupConfig,
    tabList: TabList
  },
  QA: {
    name: 'Quality Assurance',
    env: 'qa',
    uiHost: 'https://connectuqa.vodacom.co.za',
    uiBase: '/',
    apiHost: 'https://apiqa.vodacom.co.za/connectu/v1',
    apiBase: '/',
    j4uHost: 'https://apiqa.vodacom.co.za/connectu/j4u/v2',
    j4uBase: '/',
    advancesHost: 'https://apiqa.vodacom.co.za/connectu/advances/v1',
    advancesBase: '/',
    authHost: 'https://apiqa.vodacom.co.za/connectu/auth/v1',
    authBase: '/',
    catalogueHost: 'https://apiqa.vodacom.co.za/connectu/ecom/catalogue/rest/services/v1',
    catalogueBase: '/',
    checkoutHost: 'https://apiqa.vodacom.co.za/connectu/ecom/order/rest/services/v1',
    checkoutBase: '/',
    socialBundleHost: 'https://apiqa.vodacom.co.za/connectu/socialbundle/v1',
    socialBundleBase: '/',
    assetBase: '/assets/',
    drupalBaseUrl: 'https://connectuqa.vodacom.co.za',
    headerEnrichmentUrl: 'https://enrichmentstg.vodacom.co.za/cloud/enrichment/loader',
    sentryEnv: 'qa',
    sentryTracesSampleRate: 1.0,
    locationTimeout: 30000,
    cities: Cities,
    technicalErrorDetails: TechnicalErrorDetails,
    popupConfig: PopupConfig,
    tabList: TabList
  },
  Staging: {
    name: 'Staging',
    env: 'stg',
    uiHost: 'https://connectustg.vodacom.co.za',
    uiBase: '/',
    apiHost: 'https://apistg.vodacom.co.za/connectu/v1',
    apiBase: '/',
    j4uHost: 'https://apistg.vodacom.co.za/connectu/j4u/v2',
    j4uBase: '/',
    advancesHost: 'https://apistg.vodacom.co.za/connectu/advances/v1',
    advancesBase: '/',
    authHost: 'https://apistg.vodacom.co.za/connectu/auth/v1',
    authBase: '/',
    catalogueHost: 'https://apistg.vodacom.co.za/connectu/ecom/catalogue/rest/services/v1',
    catalogueBase: '/',
    checkoutHost: 'https://apistg.vodacom.co.za/connectu/ecom/order/rest/services/v1',
    checkoutBase: '/',
    socialBundleHost: 'https://apistg.vodacom.co.za/connectu/socialbundle/v1',
    socialBundleBase: '/',
    assetBase: '/assets/',
    drupalBaseUrl: 'https://connectustg.vodacom.co.za',
    headerEnrichmentUrl: 'https://enrichmentstg.vodacom.co.za/cloud/enrichment/loader',
    sentryEnv: 'staging',
    sentryTracesSampleRate: 1.0,
    locationTimeout: 30000,
    cities: Cities,
    technicalErrorDetails: TechnicalErrorDetails,
    popupConfig: PopupConfig,
    tabList: TabList
  },
  Prod: {
    name: 'Production',
    env: 'prod',
    uiHost: 'https://connectu.vodacom.co.za',
    uiBase: '/',
    apiHost: 'https://api.vodacom.co.za/connectu/v1',
    apiBase: '/',
    j4uHost: 'https://api.vodacom.co.za/connectu/j4u/v2',
    j4uBase: '/',
    advancesHost: 'https://api.vodacom.co.za/connectu/advances/v1',
    advancesBase: '/',
    authHost: 'https://api.vodacom.co.za/connectu/auth/v1',
    authBase: '/',
    catalogueHost: 'https://api.vodacom.co.za/connectu/ecom/catalogue/rest/services/v1',
    catalogueBase: '/',
    checkoutHost: 'https://api.vodacom.co.za/connectu/ecom/order/rest/services/v1',
    checkoutBase: '/',
    socialBundleHost: 'https://api.vodacom.co.za/connectu/socialbundle/v1',
    socialBundleBase: '/',
    assetBase: '/assets/',
    drupalBaseUrl: 'https://connectu.vodacom.co.za',
    headerEnrichmentUrl: 'https://enrichment.vodacom.co.za/cloud/enrichment/loader',
    sentryEnv: 'production',
    sentryTracesSampleRate: 0.4,
    locationTimeout: 30000,
    cities: Cities,
    technicalErrorDetails: TechnicalErrorDetails,
    popupConfig: PopupConfig,
    tabList: TabList
  }
};

Environment.init(Environments);